export default __webpack_public_path__ + "static/media/aerosmith.c85a88cd.jpg";